export class InvalidBookingNumberError extends Error {
  constructor(message = 'Invalid booking number') {
    super(message);
    this.name = 'InvalidBookingNumberError';
  }
}
